/**
 * MapLabels Helper Functions
 * Coordinate conversion and color utilities for map labels
 */

/**
 * Convert SVG coordinates to percentage position within container
 */
export const svgToPercent = (svgX, svgY, viewBox) => {
  if (!viewBox?.width || !viewBox?.height) return null;
  return {
    x: ((svgX - viewBox.x) / viewBox.width) * 100,
    y: ((svgY - viewBox.y) / viewBox.height) * 100,
  };
};

/**
 * Get center coordinates from place attributes
 */
export const getCenterFromPlace = (place) => {
  const { attributes, center } = place;

  if (center) return { x: center.x, y: center.y };

  if (attributes?.cx !== undefined) {
    return { x: parseFloat(attributes.cx), y: parseFloat(attributes.cy) };
  }

  if (attributes?.x !== undefined && attributes?.width !== undefined) {
    return {
      x: parseFloat(attributes.x) + parseFloat(attributes.width) / 2,
      y: parseFloat(attributes.y) + parseFloat(attributes.height) / 2,
    };
  }

  return null;
};

/**
 * Get contrast text color (white or black) based on background brightness
 */
export const getContrastTextColor = (hexColor) => {
  if (!hexColor) return '#ffffff';
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? '#333333' : '#ffffff';
};
